__turbopack_context__.v({
  "border": "LevelSelectionChart-module-scss-module__Rp_nlW__border",
  "btn": "LevelSelectionChart-module-scss-module__Rp_nlW__btn",
  "btn-alt": "LevelSelectionChart-module-scss-module__Rp_nlW__btn-alt",
  "btn-default": "LevelSelectionChart-module-scss-module__Rp_nlW__btn-default",
  "btn-default-dark-bg": "LevelSelectionChart-module-scss-module__Rp_nlW__btn-default-dark-bg",
  "btn-disabled": "LevelSelectionChart-module-scss-module__Rp_nlW__btn-disabled",
  "btn-elite": "LevelSelectionChart-module-scss-module__Rp_nlW__btn-elite",
  "btn-gold": "LevelSelectionChart-module-scss-module__Rp_nlW__btn-gold",
  "btn-lg": "LevelSelectionChart-module-scss-module__Rp_nlW__btn-lg",
  "btn-link": "LevelSelectionChart-module-scss-module__Rp_nlW__btn-link",
  "btn-plat": "LevelSelectionChart-module-scss-module__Rp_nlW__btn-plat",
  "btn-primary": "LevelSelectionChart-module-scss-module__Rp_nlW__btn-primary",
  "btn-sm": "LevelSelectionChart-module-scss-module__Rp_nlW__btn-sm",
  "btn-success": "LevelSelectionChart-module-scss-module__Rp_nlW__btn-success",
  "btn-warning": "LevelSelectionChart-module-scss-module__Rp_nlW__btn-warning",
  "button_elite": "LevelSelectionChart-module-scss-module__Rp_nlW__button_elite",
  "button_gold": "LevelSelectionChart-module-scss-module__Rp_nlW__button_gold",
  "button_platinum": "LevelSelectionChart-module-scss-module__Rp_nlW__button_platinum",
  "cancelText": "LevelSelectionChart-module-scss-module__Rp_nlW__cancelText",
  "desktop": "LevelSelectionChart-module-scss-module__Rp_nlW__desktop",
  "disabled": "LevelSelectionChart-module-scss-module__Rp_nlW__disabled",
  "elite": "LevelSelectionChart-module-scss-module__Rp_nlW__elite",
  "eliteLevel": "LevelSelectionChart-module-scss-module__Rp_nlW__eliteLevel",
  "fontWeight": "LevelSelectionChart-module-scss-module__Rp_nlW__fontWeight",
  "gold": "LevelSelectionChart-module-scss-module__Rp_nlW__gold",
  "goldLevel": "LevelSelectionChart-module-scss-module__Rp_nlW__goldLevel",
  "levelInfo": "LevelSelectionChart-module-scss-module__Rp_nlW__levelInfo",
  "marginAuto": "LevelSelectionChart-module-scss-module__Rp_nlW__marginAuto",
  "mobile": "LevelSelectionChart-module-scss-module__Rp_nlW__mobile",
  "mostPopular": "LevelSelectionChart-module-scss-module__Rp_nlW__mostPopular",
  "platinum": "LevelSelectionChart-module-scss-module__Rp_nlW__platinum",
  "platinumLevel": "LevelSelectionChart-module-scss-module__Rp_nlW__platinumLevel",
  "price": "LevelSelectionChart-module-scss-module__Rp_nlW__price",
  "priceBackground": "LevelSelectionChart-module-scss-module__Rp_nlW__priceBackground",
  "shield_elite": "LevelSelectionChart-module-scss-module__Rp_nlW__shield_elite",
  "shield_gold": "LevelSelectionChart-module-scss-module__Rp_nlW__shield_gold",
  "shield_platinum": "LevelSelectionChart-module-scss-module__Rp_nlW__shield_platinum",
  "wrapper": "LevelSelectionChart-module-scss-module__Rp_nlW__wrapper",
});
